import { HiLightningBolt } from "react-icons/hi";

import { Button } from "shared/ui/button";

const items = [
  {
    title: "Deposit Stablecoins",
    description:
      "Mint bentoUSD+ to earn boosted APY from the underlying stablecoins. ",
  },
  {
    title: "Earn Real Yield",
    description:
      "Earn real digital dollar yield by holding bentoUSD+. Hold longer, earn more.",
  },
  {
    title: "Maximize Your Rewards",
    description:
      "Earn even more by using bentoUSD+ across DeFi protocols in the Bento ecosystem and participating in Bento’s referral program.",
  },
  {
    title: "Withdraw Anytime. No Lock-up.",
    description:
      "Withdraw instantly without any lock-up and keep all your earned yield.",
  },
];

export const DetailsBentoContent = () => {
  return (
    <div className="flex gap-5 px-6 py-9.5">
      <ul className="flex flex-col gap-7.5">
        {items.map((item, index) => {
          return (
            <li key={item.title} className="relative flex flex-col pl-7.5">
              <span className="absolute top-0 left-0 inline-flex text-current">
                {index + 1}.
              </span>
              <h4 className="leading-none text-white">{item.title}</h4>
              <p className="text-nobel mt-2 leading-[150%] font-normal">
                {item.description}
              </p>
            </li>
          );
        })}
      </ul>

      <div className="flex flex-col text-current">
        <div
          style={{
            backgroundImage: `linear-gradient(0deg, rgba(15, 15, 15, 0.5), rgba(15, 15, 15, 0.5)), radial-gradient(83.45% 69.49% at 50% 104.38%, rgba(59, 105, 255, 0.2) 0%, rgba(59, 105, 255, 0) 100%)`,
          }}
          className="flex w-[363px] grow flex-col items-center justify-center rounded-[18px]"
        >
          <div className="text-ultramarine-blue mt-14.5 flex items-center gap-1.5">
            <HiLightningBolt
              style={{
                fill: "radial-gradient(55.5% 56.44% at 57.52% 45.81%, #89A5FF 0%, #3B69FF 100%)",
              }}
            />

            <div>Boosted APY</div>
          </div>
          <div className="relative mt-3 flex items-center justify-center">
            <div className="inline-flex text-7xl leading-none text-white">
              15.5%
            </div>
          </div>
          <div className="mt-3.5 flex gap-1.5 overflow-hidden rounded-xl">
            <div className="text-nobel bg-nobel/10 rounded-md px-3 py-2">
              4.2%(HARDCODE)
            </div>
            <div className="bg-ultramarine-blue/10 text-ultramarine-blue rounded-md px-3 py-2">
              +10.3%(HARDCODE)
            </div>
          </div>
        </div>
        <Button className="mt-4 w-full" size="38" variant="current">
          <span className="text-onyx">Deposit +</span>
        </Button>
      </div>
    </div>
  );
};
